__turbopack_context__.v({
  "drawer": "FilterPanel-module-scss-module__BHwbmG__drawer",
  "groups": "FilterPanel-module-scss-module__BHwbmG__groups",
  "label": "FilterPanel-module-scss-module__BHwbmG__label",
  "leading": "FilterPanel-module-scss-module__BHwbmG__leading",
  "panel": "FilterPanel-module-scss-module__BHwbmG__panel",
  "range": "FilterPanel-module-scss-module__BHwbmG__range",
  "row": "FilterPanel-module-scss-module__BHwbmG__row",
  "rows": "FilterPanel-module-scss-module__BHwbmG__rows",
  "section": "FilterPanel-module-scss-module__BHwbmG__section",
  "title": "FilterPanel-module-scss-module__BHwbmG__title",
  "values": "FilterPanel-module-scss-module__BHwbmG__values",
});
